const enum EListType {
  BOOK_LIST = 'BookList',
  GROCERY_LIST = 'GroceryList',
  MUSIC_LIST = 'MusicList',
  SIMPLE_LIST = 'SimpleList',
  TO_DO_LIST = 'ToDoList',
}

export default EListType;
